import React, { useMemo, useState, useContext, useEffect } from 'react';
import { AppContext, AuthContext } from 'Context';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Pathname } from 'Routes';
import cn from 'classnames';
import { baseUrl, firebaseCredentials, axios, STRIPE_PUBLIC_KEY } from 'Api';
import { FormGroup, FormControlLabel, Checkbox, Box } from '@mui/material';
import RotatingLoader from 'Components/RotatingLoader';
import SoftAurora from 'Components/reactbits/SoftAurora';
import { CheckRounded } from '@mui/icons-material';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import FormSection from './components/form-section';
import CredentialField from './components/credential-field';
// eslint-disable-next-line
import { InfoModal } from "../../../../private/dashboard/info-modal/index";
import NameField from './components/name-field';
import PriceSectionLayout from './components/checkout-price-layout';
import logo from '../../../../../Assets/logo_round.png';
import pageStyles from './subscribe.module.css';
import styles from './components/page-layout/index.module.css';
import ExpressCheckout from './stripeCheckout';
import Checkout from './checkoutStripe';
import StripeElements from './components/payment-field/StripeElements';
import StripeTrialVersion from './components/payment-field/StripeTrialVersion';

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);
function Page({
  expiryYear,
  setInputValue,
  setExpiryYear,
  setExpiryMonth,
  setCardNumberStripe,
  setCvc,
  cardNumberStripe,
  cvc,
  expiryMonth,
  afflitedDetails,
  paymentChecker,
  loader,
  children,
  checked,
  setChecked,
  navigation,
  title,
  subTitle,
  handleSubmitPay,
  userEmail,
  userFirstName,
  userLastName,
  setFirstName,
  setLastName,
  purchasingProduct,
  setOpen,
  isDisabled,
  onContinue,
  planName,
  planPrice,
  promoCode,
  intervalInDays,
  planId,
  promoCodeNew,
  setPromoCodeNew,
}) {
  const { getToken } = useContext(AuthContext);
  const [credentialIsValid, setCredentialValidity] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [nameIsValid, setNameValidity] = useState(false);
  const {
    setScreatId,
    allPlans,
    subscriptionDetails,
    firstTimeOnlychecked,
    setFirstTimeOnlyChecked,
    cardNumber,
    cvvNumber,
    expirationDate,
    isTrail,
    setAppSnackbar,
    currentSelectedPlan,
    setisFromAffl,
    screatId,
    stripeUiSelector,
    switchingFunction,
    apiCALL,
    apiResponse
  } = useContext(AppContext);
  const [paymentIsValid, setPaymentValidity] = useState(false);
  const [promoErrMsg, setPromoErrMsg] = useState('');
  const [promoLoading, setPromoLoading] = useState(false);
  const [isFormFilled, setIsFormFilled] = useState(false);
  const [termsAgreed, setTermsAgreement] = useState(false);
  const [isOpenModal, setModal] = useState(false);

  const formIsFilled = useMemo(
    () => credentialIsValid && nameIsValid && paymentIsValid,
    [credentialIsValid, nameIsValid, paymentIsValid]
  );
  useEffect(() => {
    const checkValidity = () => {
      const digits = cardNumberStripe.replace(/\D/g, ''); // Remove non-digit characters
      const isAmex = digits.startsWith('34') || digits.startsWith('37');
      const isCvcValid = isAmex ? cvc?.length === 4 : cvc?.length === 3;
      const isCardNumberValid = isAmex
        ? digits.length >= 15 && digits.length <= 16
        : digits.length === 16;
      const isExpiryValid = expiryMonth?.length > 0;
      return isCvcValid && isCardNumberValid && isExpiryValid;
    };
    setIsFormFilled(checkValidity());
  }, [cvc, cardNumberStripe, expiryMonth]);

  const handleCheckboxChange = (event) => {
    setScreatId('');
    if (location.pathname === '/pay-by-manger') {
      setisFromAffl(true);
    } else {
      setisFromAffl(false);
    }
    const newChecked = event.target.checked;
    setChecked(newChecked);
    setIsFormFilled(newChecked);
    setExpiryMonth('');
    setExpiryYear('');
    setCardNumberStripe('');
    setCvc('');
    setInputValue('');
  };
  useEffect(() => {
    checked === true ? setIsFormFilled(true) : setIsFormFilled(false);
  }, [checked]);

  const onlyFirstTimeCheckbox = () => {
    setFirstTimeOnlyChecked(!firstTimeOnlychecked);
  };
  const fetchResumeData = async () => {
    try {
      const response = await axios.post(`${baseUrl}/sendToAffiliate`, {
        token: getToken(),
        affiliate_email: userEmail,
        promo_code: promoCodeNew,
      });
        switchingFunction(apiCALL?.data?.userDetails[0]);
      // setAppSnackbar({ isVisible: true, type: 'error', message: response?.data?.message });
      // setcategoryLoader(false);
    } catch (error) {
      const responseData = error?.response?.data;
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message: 'Something went wrong',
      });
    }
  };
  const fromAffilete = window.location.pathname === '/pay-by-manger';
  return (
    <div className={pageStyles.page}>
      <SoftAurora fixed />
      <div className={pageStyles.pageInner}>
        <div className={pageStyles.pageHeader}>
          <h1 className={pageStyles.pageTitle}>{title || 'Start Streaming and Sharing Today!'}</h1>
        </div>
      {isOpenModal && (
        <InfoModal
          isVisible={isOpenModal}
          title="Allow user to pay themselves."
          onHide={() => {
            setModal(false);
         switchingFunction(apiCALL?.data?.userDetails[0]);
          }}
          continueButton="Cancel"
          fromPayment="true"
          // content="You are now deleting, all videos and photos will now be a draft until you
          // Add them to a new category. Are you sure you want to continue?"
          actionButton="Send"
action={() => fetchResumeData()}
          isDelete
        />
      )}
      {purchasingProduct && <RotatingLoader />}
      <div className={pageStyles.grid}>
        {false && (
          <Box className={styles.paymentFieldInputs}>
            <FormSection title={subTitle || 'Account Information'}>
              {((navigation === '/settings/manage-users' && !fromAffilete)
                || (fromAffilete && apiResponse?.paymentMethod === true)
                || subscriptionDetails?.paymentMethods?.length > 0) && (
                <FormGroup>
                  <FormControlLabel
                    control={(
                      <Checkbox
                        style={{
                          color: '#1172D2',
                        }}
                        checked={checked}
                        onChange={handleCheckboxChange}
                      />
                    )}
                    label={
                      navigation === '/settings/manage-users'
                        ? 'Use your account information'
                        : 'Use your default card'
                    }
                  />
                  {navigation === '/settings/manage-users' && (
                    <FormControlLabel
                      control={(
                        <Checkbox
                          style={{
                            color: '#1172D2',
                          }}
                          checked={firstTimeOnlychecked}
                          onChange={onlyFirstTimeCheckbox}
                        />
                      )}
                      label={
                        navigation === '/settings/manage-users'
                        && 'Only for first year'
                      }
                    />
                  )}
                </FormGroup>
              )}
              <NameField
                checked={checked}
                afflitedDetails={afflitedDetails}
                userFirstName={userFirstName}
                userLastName={userLastName}
                onFirstNameChange={setFirstName}
                onLastNameChange={setLastName}
                setValidity={setNameValidity}
                isDisabled
              />
              <CredentialField
                checked={checked}
                afflitedDetails={afflitedDetails}
                userEmail={userEmail}
                setValidity={setCredentialValidity}
              />
              {checked === false || checked === undefined ? (
                <FormSection title="Payment Information">
                  {children}
                </FormSection>
              ) : null}
              <Box>
                <div className={styles.termsContainer}>
                  <input
                    hidden
                    id="terms-agreement"
                    onChange={(e) => {
                      setTermsAgreement(e.target.checked);
                    }}
                    type="checkbox"
                    checked={termsAgreed}
                  />

                  <div
                    onKeyPress={undefined}
                    role="button"
                    tabIndex={0}
                    className={cn({
                      [styles.termsCheckbox]: true,
                      [styles.checked]: termsAgreed,
                    })}
                    onClick={() => {
                      setTermsAgreement(!termsAgreed);
                    }}
                  >
                    {termsAgreed && (
                      <CheckRounded className={styles.termsCheckboxIcon} />
                    )}
                  </div>
                  <span className={styles.terms}>
                    <label htmlFor="terms-agreement">I agree to the </label>
                    {/* <a onClick={handleTandC}>Projector Terms of Service</a> */}
                    <Link
                      target="_blank"
                      to={Pathname.getSettingsPath(Pathname.termsAndConditions)}
                    >
                      Projector Terms of Service
                    </Link>
                    {/* <NextLink href="#">
              </NextLink> */}
                  </span>
                </div>
                <div className={styles.flexMe}>
                  <button
                    className={styles.continueButton}
                    disabled={
                      !isFormFilled
                      || loader
                      || purchasingProduct
                      || !termsAgreed
                      || (promoErrMsg && promoCodeNew?.length > 0)
                      || promoLoading
                      || (promoCodeNew?.length > 0 && promoCodeNew?.length < 6)
                    }
                    onClick={onContinue}
                  >
                    {loader === true ? (
                      <svg
                        className="loading-circle_mini"
                        width="20"
                        height="20"
                        viewBox="0 0 50 50"
                      >
                        <circle
                          className="circle"
                          cx="25"
                          cy="25"
                          r="20"
                          fill="none"
                          strokeWidth="4"
                        />
                      </svg>
                    ) : purchasingProduct && isTrail === '1' ? (
                      'Starting Trial'
                    ) : purchasingProduct ? (
                      'Purchasing Plan'
                    ) : isTrail === '1' ? (
                      'Start Trial'
                    ) : (
                      'Purchase Now'
                    )}
                  </button>
                  {/* <ExpressCheckout /> */}
                  {location.pathname === '/pay-by-manger'
                  && localStorage.getItem('paymentMode') !== 'switch'
                  && !cardNumber
                  && !cvvNumber
                  && !expirationDate ? (
                    <button
                      style={{ display: checked === true && 'none' }}
                      className={styles.continueButton}
                      onClick={() => setModal(true)}
                      disabled={isFormFilled}
                      // type="submit"
                    >
                      Let customer pay
                    </button>
                  ) : (
                    <></>
                  )}
                </div>
              </Box>
            </FormSection>
          </Box>
        )}

        <PriceSectionLayout
          fromAffilete={fromAffilete}
          setModal={setModal}
          handleCheckboxChange={handleCheckboxChange}
          navigation={navigation}
          planName={planName}
          checked={checked}
          planPrice={
            fromAffilete
              ? currentSelectedPlan?.amount
              : allPlans?.find((plan) => plan?.id === planId)?.amount
                || allPlans[0]
          }
          // Affiliate membership pricing: full amount stays the "Regular Rate";
          // the discount + effective total are rendered via the discount block.
          affiliatePricing={fromAffilete ? currentSelectedPlan?.affiliate : null}
          affiliateBaseAmount={currentSelectedPlan?.amount}
          selectedPlan={allPlans?.find((plan) => plan?.id === planId)}
          planId={planId}
          disablePromo={
            fromAffilete
            && !!currentSelectedPlan?.affiliate
            && Number(currentSelectedPlan?.affiliate?.effective_amount)
              < Number(currentSelectedPlan?.amount)
          }
          availablePlans={allPlans}
          allPlans={fromAffilete ? currentSelectedPlan : allPlans[0]}
          promoCode={afflitedDetails?.code || afflitedDetails?.affiliateCode}
          intervalInDays={
            fromAffilete
              ? currentSelectedPlan?.price_description
              : intervalInDays
          }
          promoErrMsg={promoErrMsg}
          setPromoErrMsg={setPromoErrMsg}
          promoCodeNew={promoCodeNew}
          setPromoCodeNew={setPromoCodeNew}
          promoLoading={promoLoading}
          setPromoLoading={setPromoLoading}
        />
        {screatId && <StripeElements />}
        {/* {screatId && (
  stripeUiSelector !== undefined && stripeUiSelector === 0
            ? (
<Elements stripe={stripePromise}>

              <StripeTrialVersion />
</Elements>
)
    : <StripeElements />
)} */}
      </div>
      </div>
    </div>
  );
}

export default Page;
